import { useT } from "@/content/landing";
import { Reveal } from "./Reveal";

/* TODO: replace with real references */
export function References() {
  const t = useT();
  return <section className="bg-white pb-20 sm:pb-24">
      <div className="mx-auto max-w-4xl px-4 sm:px-6">
        <Reveal>
          <div className="rounded-3xl border border-dashed border-black/15 bg-[#FAFBFC] p-8 text-center">
            <p className="text-xs font-semibold tracking-[0.18em] text-[#94A3B8] uppercase">
              Platzhalter
            </p>
            <h2 className="mt-3 text-lg font-semibold text-[#0F172A]">{t.social.title}</h2>
            <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-[#94A3B8]">
              {t.social.body}
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}